import Base from '../base';
import Tooltip from '../../components/tooltip';

import * as watchlistApi from './watchlist-api';

const icon = name => `
	<svg viewBox="0 0 16 16" class="icon icon--s">
		<use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="/icons/sprite.svg#${name}"></use>
	</svg>
`;

class WatchlistToggleButton extends Base {
	start() {
		this.on('click');

		this.icon = this.query('.js-watchlist-icon');

		this.isInWatchlist = this.options.isInWatchlist;

		this.tooltip = null;

		this.createTooltip();
	}

	onClick() {
		this.onToggleWatchlist();
	}

	createTooltip() {
		if (!this.label) {
			this.tooltip = new Tooltip(this.el).start();
		}
	}

	setTooltipContent(content) {
		this.tooltip.setContent(content);

		this.el.dataset.optionTooltipText = content;
	}

	onToggleWatchlist() {
		const { isin } = this.options;

		if (this.isInWatchlist) {
			this.removeFromWatchlist(isin);
		} else {
			this.addToWatchlist(isin);
		}
	}

	async addToWatchlist(isin) {
		try {
			this.onAdd();

			await watchlistApi.add(isin);
		} catch (e) {
			this.onRemove();
		}
	}

	onAdd() {
		this.isInWatchlist = true;

		this.icon.innerHTML = icon('watchlist-fill');
		this.el.classList.add('is-active');

		if (this.tooltip) {
			this.setTooltipContent(this.options.labelInWatchlist);
		}
	}

	async removeFromWatchlist(isin) {
		try {
			this.onRemove();

			await watchlistApi.remove(isin);
		} catch (e) {
			this.onAdd();
		}
	}

	onRemove() {
		this.isInWatchlist = false;

		this.icon.innerHTML = icon('watchlist-empty');
		this.el.classList.remove('is-active');

		if (this.tooltip) {
			this.setTooltipContent(this.options.labelNotInWatchlist);
		}
	}
}

export default WatchlistToggleButton;
